module.exports = __webpack_public_path__ + "media/assets/PostsIcon-7f4f7b81dd4a23b93ab5e4ed2fb9079b.svg";